import { ReorderButton } from "../ReorderButton/ReorderButton";
import { FeesPanel } from "./FeesPanel";
import { SwapButton } from "./SwapButton";
import { SwapPanel } from "./SwapPanel";

export type SwapPanelType = "source" | "destination";

export const SwapView = () => {
  return (
    <div className="flex flex-col gap-6 fill-t_text_primary">
      <div className="flex flex-col gap-[11px]">
        <SwapPanel type="source" />
        <ReorderButton />
        <SwapPanel type="destination" />
      </div>
      <FeesPanel />
      <SwapButton />
    </div>
  );
};
